export const EINVOICING_PROVIDER_TYPE = {
    STORECOVE: 'storecove',
    IOPOLE: 'iopole',
} as const;

export type EinvoicingProviderType = Enum<typeof EINVOICING_PROVIDER_TYPE>;
